import { TicketingNotificationFilterTypes } from "@avenueops/frontend-shared";
import { ManualNotificationType } from "@avenueops/shared-types";
import { SmartForm } from "@avenueops/web-components";
import CustomNotifications from "components/monitors/editFormReboot/CustomNotifications";
import CustomNotificationsAndSignals from "components/monitors/editFormReboot/CustomNotificationsAndSignals";
import { useFormContext, useWatch } from "react-hook-form";
import { trpc2 } from "utils/trpc";

interface Props {
  notificationPrefix: string;
  disableCustomize?: boolean;
}

export function SendbirdNotificationInput({ disableCustomize, notificationPrefix }: Props) {
  const { watch } = useFormContext();
  const notification: ManualNotificationType = useWatch({ name: notificationPrefix });
  const useMappingOverride = watch(`${notificationPrefix}.useMappingOverride`);
  const { data: sendbirdCustomerOptions } = trpc2.v2.sendbird.getCustomers.useQuery();

  return (
    <>
      <div className="col-span-4">
        <SmartForm.DropdownSelect
          name={`${notificationPrefix}.recipientValue`}
          title="Customer Id"
          options={sendbirdCustomerOptions ?? []}
          disabled={sendbirdCustomerOptions === undefined}
          onCreate={(value) => {
            return { label: value, value: value };
          }}
          placeholder={sendbirdCustomerOptions === undefined ? "No data for selected Sendbird instance" : "Sendbird Customer Id"}
        />
      </div>
      {disableCustomize ? null : useMappingOverride ? (
        <div className="col-span-6">
          <CustomNotifications
            notificationPrefix={notificationPrefix}
            notificationType={notification.manualType}
            supportedTypes={TicketingNotificationFilterTypes}
          />
        </div>
      ) : (
        <div className="col-span-6">
          <CustomNotificationsAndSignals
            notificationPrefix={notificationPrefix}
            notificationType={notification.manualType}
            supportedTypes={TicketingNotificationFilterTypes}
          />
        </div>
      )}
    </>
  );
}
